<template lang="jade">
  //- This is a component that combines all types of loading animation
  //- .col-lg-2.col-lg-offset-3.col-md-2.col-md-offset-3.col-sm-1.col-sm-offset-3.col-xs-2.col-xs-offset-0(v-if="isFetching")
  .load_wrap
    .load-6(v-if="aniKey === '6'")
      .letter-holder
        .l-1.letter
          |L
        .l-2.letter
          |o
        .l-3.letter
          |a
        .l-4.letter
          |d
        .l-5.letter
          |i
        .l-6.letter
          |n
        .l-7.letter
          |g
        .l-8.letter
          |.
        .l-9.letter
          |.
        .l-10.letter
          |.
</template>
<script>
export default {
  components: {
  },
  props: {
    aniKey: {
      type: String,
      default: '1'
    }
  },
  data () {
    return {

    }
  },
  asyncData () {
  },
  computed: {
  },
  methods: {
  }, // close methods
  ready () {
  },
  watch: {
  }
}
</script>
<style lang="scss" scoped>
@import '~__vendor_variables_scss__';
@import '~sass/_breakpoint.scss';

// for loading animation
.load_wrap {
  margin-top: -7px;
  position: fixed;
  left: 16.66667%;
  z-index: 50;
  padding-top: 0px;
  @include breakpoint(xxs) {
    left: 33%;
    margin-top: 0px;
    & .letter-holder{
      padding: 10px 16px 10px 28px;
    }
  }
}

@keyframes loadingF {
  0% {opacity: 0;}
  100% {opacity: 1;}
}

.letter-holder {padding: 16px;}

.letter {
  float: left;
  font-size: 14px;
  color: #777;
}

.load-6  {
  .letter {
    animation-name: loadingF;
    animation-duration: 1.6s;
    animation-iteration-count: infinite;
    animation-direction: linear;
  }
  .l-1 {animation-delay: .48s;}
  .l-2 {animation-delay: .6s;}
  .l-3 {animation-delay: .72s;}
  .l-4 {animation-delay: .84s;}
  .l-5 {animation-delay: .96s;}
  .l-6 {animation-delay: 1.08s;}
  .l-7 {animation-delay: 1.2s;}
  .l-8 {animation-delay: 1.32s;}
  .l-9 {animation-delay: 1.44s;}
  .l-10 {animation-delay: 1.56s;}
}



</style>



// WEBPACK FOOTER //
// Loader.vue?77ecc312